<template>
  <page-header-wrapper>
    <!-- <template v-slot:content>
        <div class="page-header-content">
          <div class="avatar">
            <a-avatar size="large" :src="avatar" />
          </div>
          <div class="content">
            <div class="content-title">
              111
              {{ timeFix }}，{{ nickname }}<span class="welcome-text"></span>
            </div>
            <div>{{ postGroup }} | {{ user.dept && user.dept.deptName }}</div>
          </div>
        </div>
      </template> -->
    <div class="home">
      <!-- <a-card :bordered="false">
          <p>Card content</p>
          <p>Card content</p>
          <p>Card content</p>
        </a-card> -->
      <div class="home_card">
        <!-- <div class="card_item">
            待预约：<span>{{ statistics01.orderToBeSent }}</span>
          </div>
          <div class="card_item">
            待确认：<span>{{ statistics01.orderToBeSent }}</span>
          </div> -->
        <div class="card_item" @click="handleLook('/dispatch/dispatchThree')">
          待派单：<span>{{ statistics01.orderToBeSent }}</span>
        </div>
        <div class="card_item" @click="handleLook('/dispatch/ten')">
          已拒绝：<span>{{ statistics01.orderTurnDown }}</span>
        </div>
        <div class="card_item" @click="handleLook('/dispatch/dispatchFive')">
          待接单：<span>{{ statistics01.pendingOrder }}</span>
        </div>
        <div class="card_item" @click="handleLook('/dispatch/dispatchSix')">
          待试压：<span>{{ statistics01.haveAccepted }}</span>
        </div>
        <div class="card_item" @click="handleLook('/dispatch/dispatchSeven')">
          待审核：<span>{{ statistics01.toBeReviewed }}</span>
        </div>
        <div class="card_item" @click="handleLook('/dispatch/dispatchEight')">
          已完成：<span>{{ statistics01.completed }}</span>
        </div>
        <div class="card_item" @click="handleLook('/dispatch/dispatchNine')">
          已作废：<span>{{ statistics01.haveBeenCancelled }}</span>
        </div>
      </div>
      <div class="home_c">
        <div class="home_c_l">
          <div class="home_c_l_t"><a-icon type="user" />客户总量</div>
          <div class="home_c_l_i" @click="handleLook('/sell/tenantTwo')">
            经销商数量：<span>{{ statistics01.byVolumeOfSales }}</span>
          </div>
          <div class="home_c_l_i" @click="handleLook('/sell/engineering')">
            水工数量：<span>{{ statistics01.quantityOfHydraulicWork }}</span>
          </div>
          <div class="home_c_l_i" @click="handleLook('/sell/inspector')">
            验收员数量：<span>{{ statistics01.numberOfPressureTesters }}</span>
          </div>
        </div>
        <div class="home_c_r">
          <div class="home_c_r_l">
            <div class="home_c_r_l_t">
              <a-icon type="sound" />
              消息
            </div>
            <div class="home_c_r_l_c" v-for="(item, index) in noticeList" :key="index" @click="handleNew(item)">
              {{ item.newsTitle }} <span>{{ item.createTime }}</span>
            </div>
          </div>
          <!-- <div class="home_c_r_r">
              <div class="home_c_r_l_t" style="border: none">
                <a-icon type="sound" />
                反馈
              </div>
            </div> -->
        </div>
      </div>
      <div class="home_f">
        <div class="home_f_h"><a-icon type="line-chart" />数据统计</div>
        <div class="home_f_r">
          <div class="home_f_l">
            <div class="home_f_l_t">
              <div></div>
              近半年试压服务统计单
            </div>
            <BarChart :chartData="chartData"></BarChart>
          </div>
          <div class="home_f_l">
            <div class="home_f_l_t">
              <div></div>
              试压情况系统
            </div>
            <Pie :chartData="chartData1"></Pie>
            <!-- <mapChart></mapChart> -->
          </div>
        </div>
      </div>
      <Detail ref="Detail"></Detail>
      <!-- <div v-show="show">{{ stortIndex }}</div> -->
    </div>
  </page-header-wrapper>
</template>
  
  <script>
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import { statHome } from '@/api/system/user'
import { noticeWay } from '@/api/system/notice'
// import Detail from '../../../notice/detail.vue'
import Detail from '../../system/notice/detail.vue'

//   import BarChart from './Charts/barChart.vue'
//   import mapChart from './Charts/map.vue'
//   import Pie from './Charts/pie.vue'
import BarChart from '../../Charts/barChart.vue'
import mapChart from '../../Charts/map.vue'
import Pie from '../../Charts/pie.vue'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper,
    BarChart,
    Pie,
    Detail,
    mapChart,
  },
  data() {
    return {
      chartData: {},
      roleGroup: {},
      postGroup: {},
      statistics01: {},
      show: false,
      chartData1: {},
      noticeList: [],
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname', 'index']),
    //   stortIndex() {
    //     console.log(this.$route, '测试数据====')
    //     const path = this.$route.path
    //     if (path === '/index') {
    //       this.getUser()
    //     }
    //     return this.$route.path
    //   },
  },
  // watch: {
  //   index()
  // },
  created() {
    console.log('测试梳理===')
    this.getUser()
  },
  mounted() {
    console.log('测试梳理===111')
  },
  methods: {
    handleLook(e) {
      this.$router.push(e)
    },
    // 点击更新
    handleNew(e) {
      this.$nextTick(() => {
        this.$refs.Detail.init(e)
      })
    },
    // 获取用户信息
    getUser() {
      // getUserProfile().then((response) => {
      //   window.console.log('response 111', response)
      //   this.user = response.data
      //   this.roleGroup = response.roleGroup
      //   this.postGroup = response.postGroup
      // })
      console.log(1111)

      statHome().then((res) => {
        console.log(res, '的点点滴滴=========测试首页数据')
        this.statistics01 = res.data.statistics01
        const obj = {
          x: [],
          y: [],
        }
        obj.x = res.data.statisticalMonthlyData01.map((v) => v.mon)
        obj.y = res.data.statisticalMonthlyData01.map((v) => v.orderCount)
        this.chartData = obj
        const objs = this.statistics01
        this.chartData1 = {
          arr: [
            { value: objs.orderToBeSent, name: '待派单' },
            { value: objs.toBeModified, name: '已拒绝' },
            { value: objs.haveAccepted, name: '待试压' },
            { value: objs.toBeReviewed, name: '待审核' },
            { value: objs.completed, name: '已完成' },
            { value: objs.haveBeenCancelled, name: '已作废' },
          ],
        }
      })
      noticeWay({ pageNum: 1, pageSize: 4 }).then((res) => {
        console.log(res, 'resresres')
        this.noticeList = res.data.records
        console.log(this.noticeList, 'noticeListnoticeList')
      })
    },
    onSponsorTabChange(key, type) {
      this[type] = key
    },
  },
}
</script>
  
  <style lang="less" scoped>
//   @import './index.less';
.home {
  padding: 8px;
  padding-bottom: 0;
  height: 81.5vh;
  overflow-y: auto;
  .ant-card-grid {
    border: none !important;
    // background: red;
  }
  .home_card {
    // background: red;
    display: flex;
    align-items: center;
    background: #fff;
    height: 80px;
    border-radius: 8px;
    cursor: pointer;
    transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
    &:hover {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
    }
    // flex-wrap: nowrap;
    .card_item {
      display: inline-block;
      width: 14.2%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      cursor: pointer;
      border-right: 1px solid #e5e5e5;
      &:last-child {
        border: none;
      }
      span {
        font-weight: bold;
      }
    }
  }
  .home_c {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    .home_c_l {
      width: 40%;
      background: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      margin-right: 10px;
      height: 185px;
      cursor: pointer;
      padding: 20px;
      &:hover {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
      }
      transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
      .home_c_l_t {
        font-size: 18px;
        font-weight: 500;
        // margin-bottom: 10px;
      }
      .home_c_l_i {
        // height: 30px;
        padding: 8px 0;
        border-bottom: 1px solid #e5e5e5;
        span {
          color: #1a73e8;
          font-weight: 800;
        }
      }
    }
    .home_c_r {
      flex: 1;
      height: 185px;
      cursor: pointer;
      padding: 20px;
      background: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      display: flex;
      padding: 20px;
      &:hover {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
      }
      transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
      .home_c_r_l_t {
        font-size: 18px;
        font-weight: 500;
        border-right: 1px solid #e5e5e5;
      }
      .home_c_r_l {
        // width: 49%;
        width: 100%;
        margin-right: 20px;
        .home_c_r_l_c {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  .home_f {
    margin-top: 10px;
    // display: flex;
    .home_f_h {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .home_f_r {
      display: flex;
      justify-content: space-between;
      .home_f_l {
        width: 49%;
        background: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        height: 442px;
        transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
        &:hover {
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
        }
        .home_f_l_t {
          padding-left: 20px;
          margin-top: 20px;
          font-size: 18px;
          display: flex;
          color: #000;
          font-weight: bold;
          align-content: center;
          div {
            width: 4px;
            height: 18px;
            background: #1a73e8;
            margin-right: 15px;
            border-radius: 2px;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
.ant-layout-content {
  margin: 0 !important;
}
</style>
  